const invoicesModel = vm => ({
  title: vm.$gettext('Invoices'),
  endpoint: 'invoices',
  fields: [
    {
      key: 'id',
      sortable: true
    },
    {
      key: 'account_id',
      label: vm.$gettext('Account ID'),
      sortable: true
    },
    {
      key: 'external_id',
      label: vm.$gettext('External ID'),
      sortable: true
    },
    {
      key: 'type_id',
      label: vm.$gettext('Type ID'),
      sortable: true
    },
    {
      key: 'gross_amount',
      label: vm.$gettext('Gross Amount'),
      sortable: false
    },
    {
      key: 'invoice_url',
      label: vm.$gettext('Invoice URL'),
      sortable: false,
      type: 'link'
    },
    {
      key: 'generation_date',
      label: vm.$gettext('Generation Date'),
      sortable: true
    },
    {
      key: 'created_at',
      label: vm.$gettext('Created At'),
      sortable: false
    }
  ],
  includes: ['account_transactions'],
  filters: [
    'id',
    'account_id',
    'external_id',
    'generation_date',
    'account_transactions.shipping_id',
    'account_transactions.courier_id'
  ]
})

export default invoicesModel
